module.exports = __webpack_public_path__ + "static/img/bcd7seg-1.e76bd98.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/bcd7seg-1.svg
// module id = BCrT
// module chunks = 0